module.exports = __webpack_public_path__ + "img/delete-circle.b9c956a2.svg";